import { render, staticRenderFns } from "./Grid23.vue?vue&type=template&id=593fb624&scoped=true"
import script from "./Grid23.vue?vue&type=script&lang=ts"
export * from "./Grid23.vue?vue&type=script&lang=ts"
import style0 from "./Grid23.vue?vue&type=style&index=0&id=593fb624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593fb624",
  null
  
)

export default component.exports